(function() {
  if (window.__cartReassuranceSwiperLoaded) {
    return;
  }

  window.__cartReassuranceSwiperLoaded = true;

  var instances = new WeakMap();
  var syncTimer = null;
  var miniCartObserver = null;

  function initSwiper(swiperElement) {
    if (!swiperElement || typeof Swiper === 'undefined') {
      return;
    }

    if (instances.has(swiperElement)) {
      var existingSwiper = instances.get(swiperElement);
      if (existingSwiper && typeof existingSwiper.update === 'function') {
        existingSwiper.update();
      }
      return;
    }

    var container = swiperElement.closest('.reassurance-slider');
    if (!container) {
      return;
    }

    var prevButton = container.querySelector('[data-element="reassurance-prev-cart"]');
    var nextButton = container.querySelector('[data-element="reassurance-next-cart"]');

    var swiper = new Swiper(swiperElement, {
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      allowTouchMove: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true
      },
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton
      }
    });

    instances.set(swiperElement, swiper);
  }

  function syncSwipers() {
    var swipers = document.querySelectorAll('[data-element="reassurance-swiper-cart"]');

    swipers.forEach(function(swiperElement) {
      initSwiper(swiperElement);
    });
  }

  function scheduleSync(delay) {
    if (syncTimer) {
      window.clearTimeout(syncTimer);
    }

    syncTimer = window.setTimeout(function() {
      syncWhenReady();
    }, typeof delay === 'number' ? delay : 120);
  }

  function syncWhenReady() {
    if (typeof Swiper === 'undefined') {
      scheduleSync(150);
      return;
    }

    syncSwipers();
  }

  function bindMiniCartObserver() {
    if (miniCartObserver) {
      return;
    }

    var miniCartSection = document.querySelector('#shopify-section-mini-cart')
      || document.querySelector('[data-section-type="mini-cart-section"]');

    if (!miniCartSection) {
      scheduleSync(200);
      return;
    }

    miniCartObserver = new MutationObserver(function() {
      scheduleSync(100);
    });

    miniCartObserver.observe(miniCartSection, {
      childList: true,
      subtree: true
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    syncWhenReady();
    bindMiniCartObserver();
  });

  document.addEventListener('shopify:section:load', function() {
    bindMiniCartObserver();
    scheduleSync(80);
  });

  document.addEventListener('cart:updated', function() {
    syncWhenReady();
  });

  document.addEventListener('product:added', function() {
    syncWhenReady();
  });

  document.addEventListener('click', function(event) {
    if (event.target.closest('[data-action="toggle-mini-cart"]')) {
      scheduleSync(80);
    }
  });
})();
